export const ReportStatusEnum = {
    QUEUED: {code: 'QUEUED', nameRu: "В очереди на формирование отчета"},
    FILES_GENERATING: {code: 'FILES_GENERATING', nameRu: "Отчет формируется"},
    FILES_GENERATED: {code: 'FILES_GENERATED', nameRu: "Отчет сформирован"}, // Файлы сформированы, доступно для менеджеров вузов

    SENT_FOR_APPROVAL: {code: 'SENT_FOR_APPROVAL', nameRu: "Отправлен на согласование"}, // Отправлен менеджеру финансового центра

    REJECTED_BY_FINANCIAL_CENTER: {code: 'REJECTED_BY_FINANCIAL_CENTER', nameRu: "Отклонен менеджером финансового центра"}, // Отклонен финансовым центром

    SENT_TO_RECTOR: {code: 'SENT_TO_RECTOR', nameRu: "Отправлен ректору"}, // Отправлен ректору вуза
    SIGNED_BY_RECTOR: {code: 'SIGNED_BY_RECTOR', nameRu: "Подписан ректором"}, // Подписан ректором
    REJECTED_BY_RECTOR: {code: 'REJECTED_BY_RECTOR', nameRu: "Отклонен ректором"},

    ERROR_ON_FILES_GENERATING: {code: 'ERROR_ON_FILES_GENERATING', nameRu: "Возникла неизвестная ошибка при формировании файлов"},
};